import { render, staticRenderFns } from "./moblie.vue?vue&type=template&id=04238108&scoped=true"
import script from "./moblie.vue?vue&type=script&lang=js"
export * from "./moblie.vue?vue&type=script&lang=js"
import style0 from "./moblie.vue?vue&type=style&index=0&id=04238108&prod&lang=scss&scoped=true"
import style1 from "./moblie.vue?vue&type=style&index=1&id=04238108&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04238108",
  null
  
)

export default component.exports